module.exports = __webpack_public_path__ + "img/2939550.jpg";